import { useEffect, useState } from 'react';
import { updateCp } from '../../redux/cp/cpSlice';
import { useDispatch, useSelector } from 'react-redux';

const useHook = () => {
  const dispatch = useDispatch();
  const reduxCp = useSelector((state: any) => state.cp.cp);
  const [cp, setCp] = useState("");
  const [loading, setLoading] = useState(false);
  const [shippings, setShippings] = useState<any[]>([]);

  const diasDePreparacion = 2;

  const handleChange = (e: string) => {
    if (/^\d{0,4}$/.test(e)) {
      setCp(e);
      if (e.length === 4) {
        dispatch(updateCp(e));
      }
    }
  };

  const handleClean = () => {
    dispatch(updateCp(""));
    setCp("");
  };

  async function getShipments(cp: string) {
    setLoading(true);
    const body = {
      cp: cp,
      weight: 1,
      types: "ship_pas,ship_pap"
    };
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/envios/cotizar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const result = await response.json();
      // esto para agrupar sucursales repetidas
      const shippingsUnique = result?.results?.filter(
        (current: any, index: number, self: any[]) =>
          index === self.findIndex(
            (s: any) =>
              s.ship_to?.address?.address_line === current.ship_to?.address?.address_line &&
                            s.shipping_service?.carrier?.name === current.shipping_service?.carrier?.name
          )
      );
      setShippings(shippingsUnique ?? []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setCp(reduxCp);
    if (typeof window !== 'undefined' && reduxCp?.length === 4) {
      getShipments(reduxCp);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reduxCp]);

  return {
    cp,
    reduxCp,
    loading,
    shippings,
    diasDePreparacion,
    handleChange,
    handleClean,
  };
};

export default useHook;
